<template>
  <!-- 微信代金券 weChatVoucher edit-->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
      width='700px'
    >
    <div class="box">
        <ul class=" box_ul">
          <li><span>代金券批次号：</span><div>{{detailData.stockId}}</div></li>
          <li><span>券名称：</span><div>{{detailData.stockName}}</div></li>
          <li><span>面额：</span><div>{{detailData.couponAmount}}</div></li>
          <li><span>订单需满：</span><div>{{detailData.transactionMinimum}}</div></li>
          <li><span>参与次数限制：</span><div>{{detailData.maxCouponsPerUser}}</div></li>
          <li><span>可用时间：</span><div>{{detailData.availableTime}}</div></li>
          <!-- <li><span>券生效时间：</span><div>{{detailData.}}</div></li> -->
          <li><span>批次状态：</span><div>{{detailData.statusDesc}}</div></li>
          <li><span>发放总上限：</span><div>{{detailData.maxCoupons}}</div></li>
          <li><span>已发券总量：</span><div>{{detailData.distributedCoupons}}</div></li>
          <li><span>平台发放上限：</span><div><a-input v-model="detailData.publishNum"/></div></li>
          <li><span>平台已发券总量：</span><div>{{detailData.useNum}}</div></li>
          <li><span>使用说明：</span><div>{{detailData.distribution}}</div></li>
        </ul>
      </div>

    </a-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: undefined,
      detailData: {},
      modalTitle: '编辑',
      visible: false
    };
  },
  created () {
  },
  methods: {
    show (id) {
      this.id = id;
      this.$get({
        url: `/pm/wx/coupon/${id}`
      }).then(({data}) => {
        this.detailData = data;
      });
      setTimeout(() => {
        this.visible = true;
      }, 100);
    },
    okFun () {
      let num = this.detailData.publishNum;
      if (!isNaN(num) && (num % 1 == 0) && num >= 0) {
        let number = Number(num);
        this.$put({
          url: `/pm/wx/coupon/${this.id}`,
          params: {
            publishNum: number
          }
        }).then((res) => {
          this.$message.success('操作成功');
          this.visible = false;
          this.$parent.$refs.table.getTableList();
        });
      } else {
        this.$message.error('请输入正整数');
      }
    },

    closeFun () {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  vertical-align: middle;
}
.box_ul{
  list-style: none;
  width:100%;
  li{
    line-height: 45px;
    width:100%;
    span{
      display: inline-block;
      width:30%;
      text-align: right;
      vertical-align: top;
    }
    div{display: inline-block;
      width:60%;
      clear:both;
    }
  }
}
</style>
